<div class="flex items-center gap-3 pl-10">
  <div class="flex w-10 flex-col">
    <span [class]="titleClass()">{{ name() | translate | uppercase }}</span>
    <span class="text-h6 font-thin text-states-grey">{{ label() | translate }}</span>
  </div>
  <div class="flex gap-1">
    @for (value of valueSet; track $index) {
      <button [class]="getButtonClassList(value)" (click)="onButtonClick(value)">
        <span>
          {{ numberDisplayType() === 'roman' ? romanNumerals[value] : value }}
        </span>
      </button>
    }
  </div>
</div>
